
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { CircularProgress, Backdrop } from "@mui/material";
import MenuItem from '@mui/material/MenuItem';
import { State } from 'country-state-city';
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import MDEditor from "components/MDEditor";
import { handleErrors } from "common";
import RenderCustomField from "layouts/components/RenderCustomField";
import { PROFILE } from "constants";

function Profile() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [response, setResponseData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const states = State.getStatesOfCountry("IN");
  const [customFields, setCustomFields] = useState([]);
  const [selectedCustomMultiselect, setSelectedCustomMultiselect] = useState([]); // State to store selected options
  const profileCompleteStatus = localStorage.getItem('profileCompleteStatus');

  const { register, handleSubmit, formState: { errors }, setValue, getValues, setError, control } = useForm();

  useEffect(() => {
    if (profileCompleteStatus == PROFILE.IS_INCOMPLETE)
      toast.success(t('profileCompletionNote'))
  }, []);

  const fetchData = async () => {
    setIsLoading(true)
    await axios.get(baseUrl + '/vendor/editProfile/', {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    }).then((response) => {
      setIsLoading(false);
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const responseData = response.data.data;
          setResponseData(responseData);
          Object.entries(responseData).forEach(([key, value]) => {
            if (key === 'deliveryDays' && value != null) {
              if (value == 0)
                setValue('deliveryDays', '')
              else
                setValue('deliveryDays', parseInt(value));
            }
            else if (key === 'returnDays' && value != null) {
              if (value == 0)
                setValue('returnDays', '')
              else
                setValue('returnDays', parseInt(value));
            }
            else if (key === 'refundDays' && value != null) {
              if (value == 0)
                setValue('refundDays', '')
              else
                setValue('refundDays', parseInt(value));
            }
            else if (key == 'customFields' && value.length > 0) {
              setCustomFields(value);
              value.map((item) => {
                if (item.fieldType == 6) {
                  setSelectedCustomMultiselect((selectedCustomMultiselect) => ({
                    ...selectedCustomMultiselect,
                    [item.fieldName]: item.value,
                  }));
                }
              })
            }
            else {
              setValue(key, value);
            }
          });
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let inputData = {};
    inputData.id = data['id'];
    inputData.email = data['email'];
    inputData.name = data['name'];
    inputData.shopName = data['shopName'];
    inputData.address = data['address'];
    inputData.city = data['city'];
    inputData.state = data['state'];
    inputData.zipCode = data['zipCode'];
    inputData.mobileNumber = data['mobileNumber'];
    inputData.shortDescription = data['shortDescription'];
    inputData.detailedDescription = data['detailedDescription'];
    inputData.deliveryDays = data['deliveryDays'];
    inputData.returnDays = data['returnDays'];
    inputData.refundDays = data['refundDays'];

    const customFieldData = customFields.map((item) => {
      if (item.fieldType !== 7) {
        if (item.fieldType == 6) {
          const id = item.id;
          const value = selectedCustomMultiselect[item.fieldName];
          return {
            id: id,
            value: value,
          };
        }
        else {
          const id = item.id;
          const value = data[item.fieldName];
          return {
            id: id,
            value: value,
          };
        }

      } else {
        return {
          id: item.id,
          value: item.fileData ? item.fileData : item.value,
          fileType: item.fileType,
          azureId: item.azureId
        };
      }
    });
    inputData.customFields = customFieldData;

    setIsLoading(true)
    axios.post(baseUrl + '/vendor/updateProfile', inputData, {
      headers: { Authorization: bearerToken }
    }).then((response) => {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        const profileCompleteStatus = response.data.data.profileCompleteStatus;
        if (status == 1) {
          localStorage.setItem("profileCompleteStatus", profileCompleteStatus)
          toast.success(t(message))
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false)
      handleErrors(error, t, navigate);
    });
  }

  useEffect(() => {
    register('shortDescription', {
      required: {
        value: true,
        message: t('shortDescriptionRequired')
      }
    }
    );
    register('detailedDescription', {
      required: {
        value: true,
        message: t('detailedDescriptionRequired')
      }
    });
  }, [register]);

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t('myAccount')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading} >
        <CircularProgress color="inherit" />
      </Backdrop>
      {response ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} pt={3} pb={3}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={0}>

                      <Grid item xs={12} sm={12} md={12}>
                        <MDTypography variant="h6" style={{ textTransform: 'uppercase' }}>{t('accountDetails')}</MDTypography>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle"> {t('email')} </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="email"
                          disabled={true}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("email", {
                            required: {
                              value: true,
                              message: t('emailRequired')
                            },
                            pattern: {
                              value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                              message: t('invalidEmail')
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('sellerName')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="name"
                          placeholder={t('enterSellerName')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("name", {
                            required: {
                              value: true,
                              message: t('nameRequired')
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.name && (
                          <span className="errorMsg floatRight">{errors.name.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('shopName')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="shopName"
                          placeholder={t('enterShopName')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("shopName", {
                            required: {
                              value: true,
                              message: t('shopNameRequired')
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />

                        {errors.shopName && (
                          <span className="errorMsg floatRight">{errors.shopName.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('address')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="address"
                          placeholder={t('physicalAddress')}
                          multiline
                          maxRows={8}
                          InputProps={{
                            classes: { root: "textareaHeight" },
                          }}
                          {...register("address", {
                            required: {
                              value: true,
                              message: t('addressRequired')
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.address && (
                          <span className="errorMsg floatRight">{errors.address.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('country')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="country"
                          value="India"
                          disabled={true}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          fullWidth />
                      </Grid>


                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('state')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <Controller
                          name="state"
                          control={control}
                          rules={{
                            required: {
                              value: true,
                              message: t('stateRequired')
                            },
                            validate: (value) => {
                              if (value === "0") {
                                return t('stateRequired');
                              }
                              return true;
                            },
                          }}
                          defaultValue={response.state ? response.state : "0"}
                          render={({ field }) => (
                            <MDInput
                              select
                              {...field}
                              fullWidth
                              InputProps={{
                                classes: { root: "select-input-styles dropdownPadding" },
                              }}
                            >
                              <MenuItem key={"select-state"} value="0">{t("select")}</MenuItem>
                              {states.map((state) => (
                                <MenuItem key={state.isoCode} value={state.isoCode}>{state.name}</MenuItem>
                              ))}
                            </MDInput>
                          )}
                        />
                        {errors.state && (
                          <span className="errorMsg floatRight">{errors.state.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('city')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="city"
                          placeholder={t('enterCityName')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("city", {
                            required: {
                              value: true,
                              message: t('cityRequired')
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.city && (
                          <span className="errorMsg floatRight">{errors.city.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('zipCode')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="zipCode"
                          placeholder={t('enterZipcodeHere')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("zipCode", {
                            required: {
                              value: true,
                              message: t('zipCodeRequired')
                            },
                            pattern: {
                              value: /^\d{6}$/,
                              message: t('invalidzipCode')
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.zipCode && (
                          <span className="errorMsg floatRight">{errors.zipCode.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('mobileNumber')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="mobileNumber"
                          placeholder={t('enterSellerContact')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("mobileNumber", {
                            required: {
                              value: true,
                              message: t('mobileNumberRequired')
                            },
                            pattern: {
                              value: /^[0-9]{10}$/,
                              message: t('mobileNumberInvalidFormat')
                            }
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth
                        />
                        {errors.mobileNumber && (
                          <span className="errorMsg floatRight">{errors.mobileNumber.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('shortDescription')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDEditor
                          value={getValues('shortDescription')}
                          onChange={(updatedContent) => {
                            setValue('shortDescription', updatedContent);
                          }}
                        />
                        {errors.shortDescription && (
                          <span className="errorMsg floatRight">{errors.shortDescription.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('detailedDescription')}
                          <MDTypography component="span" variant="body2" fontWeight="bold" color="error" >*</MDTypography>
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDEditor
                          value={getValues('detailedDescription')}
                          onChange={(updatedContent) => {
                            setValue('detailedDescription', updatedContent);
                          }}
                        />
                        {errors.detailedDescription && (
                          <span className="errorMsg floatRight">{errors.detailedDescription.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('deliveryDays')}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="deliveryDays"
                          placeholder={t('enterDeliveryDays')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("deliveryDays", {
                            pattern: {
                              value: /^[1-9][0-9]*$/,
                              message: t('invalidNumberOfDays'),
                            },
                            min: {
                              value: 1,
                              message: t('invalidNumberOfDays'),
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.deliveryDays && (
                          <span className="errorMsg floatRight">{errors.deliveryDays.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('returnDays')}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="returnDays"
                          placeholder={t('enterReturnDays')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("returnDays", {
                            pattern: {
                              value: /^[1-9][0-9]*$/,
                              message: t('invalidNumberOfDays'),
                            },
                            min: {
                              value: 1,
                              message: t('invalidNumberOfDays'),
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                        {errors.returnDays && (
                          <span className="errorMsg floatRight">{errors.returnDays.message}</span>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography variant="body1" className="labelStyle">
                          {t('refundDays')}
                          {errors.refundDays && (
                            <span className="errorMsg floatRight">{errors.refundDays.message}</span>
                          )}
                        </MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDInput
                          type="text"
                          name="refundDays"
                          placeholder={t('enterRefundDays')}
                          InputProps={{
                            classes: { root: "inputBoxStyle" },
                          }}
                          {...register("refundDays", {
                            pattern: {
                              value: /^[1-9][0-9]*$/,
                              message: t('invalidNumberOfDays'),
                            },
                            min: {
                              value: 1,
                              message: t('invalidNumberOfDays'),
                            },
                          })}
                          onChange={((e) => { e.stopPropagation() })}
                          fullWidth />
                      </Grid>
                      <Grid item xs={12} lg={12} sm={12} md={12}>
                        <MDTypography variant="h6" style={{ textTransform: 'uppercase' }}>{t('extraInformation')}</MDTypography>
                      </Grid>
                      <Grid item xs={12} lg={12} sm={12} md={12}>
                        {customFields && customFields.map((item) => <RenderCustomField key={item.id}
                          dataFrom={"vendor"}
                          item={item}
                          from="general"
                          selectedCustomMultiselect={selectedCustomMultiselect}
                          errors={errors}
                          register={register}
                          control={control}
                          setValue={setValue}
                          setError={setError}
                          t={t}
                          setSelectedCustomMultiselect={setSelectedCustomMultiselect}
                          customFields={customFields}
                          setCustomFields={setCustomFields}
                          setIsLoading={setIsLoading}
                        />)}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}></Grid>
                      <Grid item xs={12} sm={8} md={8}>
                        <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('submit')}</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null}

    </DashboardLayout >
  );
}

export default Profile;
